import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10" }
const _hoisted_4 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px","flex":"1 1 auto"}
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_19 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_20 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_21 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_22 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_23 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  colspan: "15",
  class: "text-center py-5 text-muted"
}
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_35 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_36 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_37 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_39 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_40 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_41 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_42 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_43 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_44 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_45 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_46 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_47 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_48 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_49 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_50 = { class: "dropdown" }
const _hoisted_51 = { class: "dropdown-menu" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "" }
const _hoisted_58 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_59 = { class: "mb-0 text-paragraph" }
const _hoisted_60 = { class: "fw-bold" }
const _hoisted_61 = { class: "fw-bold" }
const _hoisted_62 = { class: "fw-bold" }
const _hoisted_63 = {
  key: 0,
  class: "mt-15 mt-md-0"
}
const _hoisted_64 = { class: "pagination mb-0" }
const _hoisted_65 = {
  key: 0,
  class: "page-item"
}
const _hoisted_66 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = {
  key: 1,
  class: "page-item"
}
const _hoisted_69 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_70 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_71 = { class: "modal-content" }
const _hoisted_72 = { class: "modal-header" }
const _hoisted_73 = { class: "modal-title fs-5" }
const _hoisted_74 = { class: "modal-body" }
const _hoisted_75 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_76 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_77 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_78 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_79 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_80 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_84 = ["placeholder"]
const _hoisted_85 = { class: "invalid-feedback" }
const _hoisted_86 = { class: "col-md-6" }
const _hoisted_87 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_88 = ["placeholder"]
const _hoisted_89 = { class: "invalid-feedback" }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col-md-6" }
const _hoisted_92 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_93 = { value: "" }
const _hoisted_94 = { class: "col-md-6" }
const _hoisted_95 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_96 = ["placeholder"]
const _hoisted_97 = { class: "invalid-feedback" }
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-md-6" }
const _hoisted_100 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_101 = ["placeholder"]
const _hoisted_102 = { class: "invalid-feedback" }
const _hoisted_103 = { class: "col-md-6" }
const _hoisted_104 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_105 = { value: "" }
const _hoisted_106 = { value: "1" }
const _hoisted_107 = { value: "2" }
const _hoisted_108 = { value: "3" }
const _hoisted_109 = { class: "row" }
const _hoisted_110 = { class: "col-md-6" }
const _hoisted_111 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_112 = { value: "" }
const _hoisted_113 = ["value"]
const _hoisted_114 = { class: "col-md-6" }
const _hoisted_115 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_116 = { value: "" }
const _hoisted_117 = { value: false }
const _hoisted_118 = { value: true }
const _hoisted_119 = { class: "row" }
const _hoisted_120 = { class: "col-md-6" }
const _hoisted_121 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_122 = ["placeholder"]
const _hoisted_123 = { class: "invalid-feedback" }
const _hoisted_124 = { class: "col-md-6" }
const _hoisted_125 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_126 = { value: "" }
const _hoisted_127 = ["value"]
const _hoisted_128 = { class: "row" }
const _hoisted_129 = { class: "col-md-6" }
const _hoisted_130 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_131 = { value: "" }
const _hoisted_132 = { value: false }
const _hoisted_133 = { value: true }
const _hoisted_134 = { class: "col-md-6" }
const _hoisted_135 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_136 = ["placeholder"]
const _hoisted_137 = { class: "invalid-feedback" }
const _hoisted_138 = { class: "row" }
const _hoisted_139 = { class: "col-md-12" }
const _hoisted_140 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_141 = ["placeholder"]
const _hoisted_142 = { class: "invalid-feedback" }
const _hoisted_143 = { class: "modal-footer" }
const _hoisted_144 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}

import { ref, onMounted, reactive, inject, computed } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { useI18n } from "vue-i18n";
import { showToast, checkSessionValidate } from "../../utils/function";
import { current_permissions } from '../../utils/permission';
import { useRoute } from 'vue-router'
import * as yup from 'yup';
import { Country, Fee, Operator, Organization, TypeFree, Provider } from "@/utils/Model";


export default /*@__PURE__*/_defineComponent({
  __name: 'OperatorContent',
  setup(__props) {

const backApi = inject('back');
const page = ref(1);
const total = ref(0);
const pagesLeft = ref(0);
const currentPage = ref(0);
const numPages = ref(0);
let edit = 0;
let itemCode = '';
let code: string | null = '';
const selectedOrganization = ref(code);
const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedTypeFee = ref('');
const selectedMode = ref('');
const btnLoad = ref(true);
const { t } = useI18n();

const selectedStatus = ref('');
const selectedPaymentMethod = ref('');
const selectedOperationType = ref('');
const selectedCheckOnlyAfterTimeout = ref<boolean | string>('');
const selectedProvider = ref('');
const selectedIsOtpRequired = ref<boolean | string>('');

let countryCode = ''
let countryName = ''

const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');

const countries = ref(new Array<Country>());
const fees = ref(new Array<Fee>());
const organizations = ref(new Array<Organization>());
const operators = ref(new Array<Operator>());
const providers = ref(new Array<Provider>());
const typefees = ref(new Array<TypeFree>());
let operatorsTemp = new Array<Operator>();
let countriesTemp = new Array<Country>();

// Variables pour la recherche
const searchQuery = ref('');
const filteredOperators = ref(new Array<Operator>());

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 
  'name': '', 
  'valeur': '', 
  'mnoName': '', 
  'description': '', 
  'otpInputMask': '',
  'paymentMethod': '',
  'phoneCode': '',
  'phoneMask': ''
};
const pageLoad = ref(false);

const formValues = reactive({
  valeur: "",
  name: "",
  mnoName: "",
  description: "",
  phoneCode: "",
  phoneMask: 0,
  paymentMethod: "",
  otpInputMask: ""
});

const schema = yup.object({
  name: yup.string().required('Le nom de l\'operateur est requis'),
  mnoName: yup.string().required('Le nom du mno est requis'),
  description: yup.string().required('La description est requise'),
  phoneCode: yup.string().required('L\'indice telephonique est requis'),
  phoneMask: yup.string().required('Le masque telephonique est requis'),
  paymentMethod: yup.string().required('La methode de paiement est requise'),
  otpInputMask: yup.string().nullable(),
});

// Computed pour les opérateurs affichés avec pagination
const displayedOperators = computed(() => {
  const dataToUse = searchQuery.value ? filteredOperators.value : operatorsTemp;
  const start = (page.value - 1) * 10;
  const end = start + 10;
  return dataToUse.slice(start, end);
});

// Computed pour les pages de pagination
const paginationPages = computed(() => {
  const pages = [];
  const totalPages = numPages.value;
  const current = page.value;
  
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    if (current <= 3) {
      for (let i = 1; i <= 5; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    } else if (current >= totalPages - 2) {
      pages.push(1);
      pages.push('...');
      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      pages.push('...');
      for (let i = current - 1; i <= current + 1; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    }
  }
  return pages;
});

const initField = () => {
  formValues.name = '';
  formValues.mnoName = "";
  formValues.description = "";
  formValues.phoneCode = "";
  formValues.phoneMask = 0;
  formValues.paymentMethod = "";
  formValues.otpInputMask = "";
  itemCode = '';
  edit = 0;
  selectedCountry.value = '';
  selectedOperationType.value = '';
  selectedProvider.value = '';
  selectedCheckOnlyAfterTimeout.value = '';
  selectedIsOtpRequired.value = '';
  selectedStatus.value = '';
  countryCode = '';
  countryName = '';
  errorId.value = '';
  errors.value = '';
}

function handleCheckOnlyAfterTimeoutChange(event) {
  const value = event.target.value;
  if (value === 'true') {
    selectedCheckOnlyAfterTimeout.value = true;
  } else if (value === 'false') {
    selectedCheckOnlyAfterTimeout.value = false;
  } else {
    selectedCheckOnlyAfterTimeout.value = '';
  }
}

function handleOperationTypeChange(event) {
  selectedOperationType.value = event.target.value;
}

function handleProviderChange(event) {
  selectedProvider.value = event.target.value;
}

function handleIsOtpRequiredChange(event) {
  const value = event.target.value;
  if (value === 'true') {
    selectedIsOtpRequired.value = true;
  } else if (value === 'false') {
    selectedIsOtpRequired.value = false;
  } else {
    selectedIsOtpRequired.value = '';
  }
}

function handleCountryChange(event) {
  var i = 0;
  while (i < countriesTemp.length) {
    if (countriesTemp[i].countryCode == event.target.value) {
      selectedCountry.value = countriesTemp[i].code;
      countryCode = countriesTemp[i].countryCode;
      countryName = countriesTemp[i].name;
    }
    i++;
  }
  var j = 0;
  var operatorArr = new Array<Operator>();
  while (j < operatorsTemp.length) {
    if (operatorsTemp[j].countryCode == event.target.value) {
      operatorArr.push(operatorsTemp[j]);
    }
    j++;
  }
  operators.value = operatorArr;
}

// Méthode utilitaire pour obtenir le label du type d'opération
const getOperationTypeLabel = (operationType: string) => {
  switch(operationType) {
    case '1': return t('operators.payin');
    case '2': return t('operators.payout');
    case '3': return t('operators.payinPayout');
    default: return '';
  }
};

// Méthode pour filtrer les opérateurs
const filterOperators = () => {
  const query = searchQuery.value.toLowerCase().trim();
  
  if (!query) {
    filteredOperators.value = [...operatorsTemp];
    updatePagination();
    return;
  }

  filteredOperators.value = operatorsTemp.filter(operator => {
    return (
      (operator.code && operator.code.toLowerCase().includes(query)) ||
      (operator.name && operator.name.toLowerCase().includes(query)) ||
      (operator.mnoName && operator.mnoName.toLowerCase().includes(query)) ||
      (operator.provider && operator.provider.name && operator.provider.name.toLowerCase().includes(query)) ||
      (operator.paymentMethod && operator.paymentMethod.toLowerCase().includes(query)) ||
      (operator.countryName && operator.countryName.toLowerCase().includes(query)) ||
      (operator.countryCode && operator.countryCode.toLowerCase().includes(query)) ||
      (operator.phoneCode && operator.phoneCode.toLowerCase().includes(query)) ||
      (operator.phoneMask && operator.phoneMask.toString().includes(query)) ||
      (operator.description && operator.description.toLowerCase().includes(query)) ||
      (operator.status && operator.status.toLowerCase().includes(query)) ||
      (operator.operationType && getOperationTypeLabel(operator.operationType).toLowerCase().includes(query))
    );
  });

  updatePagination();
};

// Méthode pour effacer la recherche
const clearSearch = () => {
  searchQuery.value = '';
  filteredOperators.value = [...operatorsTemp];
  updatePagination();
};

// Mettre à jour la pagination avec les résultats filtrés
const updatePagination = () => {
  const dataToDisplay = searchQuery.value ? filteredOperators.value : operatorsTemp;
  total.value = dataToDisplay.length;
  const itemsPerPage = 10;
  numPages.value = Math.ceil(total.value / itemsPerPage);
  if (page.value > numPages.value && numPages.value > 0) {
    page.value = numPages.value;
  } else if (numPages.value === 0) {
    page.value = 1;
  }
};

// Aller à une page spécifique
const goToPage = (pageNumber: number) => {
  if (pageNumber !== page.value && pageNumber >= 1 && pageNumber <= numPages.value) {
    page.value = pageNumber;
  }
};

const getFees = (arg = 1) => {
  // Cette méthode est conservée mais n'est plus utilisée pour la pagination
  page.value = arg;
  // Ne pas refaire d'appel API car on filtre côté client
};

const getOrganizations = () => {
  axios.get(backApi + '/secure/organizations/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      organizations.value = response.data;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const fetchProvidersPage = (targetPage: number) => {
  const url = `${backApi}/secure/providers/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getProviders = async () => {
  try {
    const first = await fetchProvidersPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchProvidersPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    providers.value = collected;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getTypeFees = () => {
  axios.get(backApi + '/secure/typefees/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      typefees.value = response.data;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const getCountries = () => {
  axios.get(backApi + '/secure/countries/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      countriesTemp = response.data;
      countries.value = response.data;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const fetchOperatorsPage = (targetPage: number) => {
  const url = `${backApi}/secure/operators/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getOperators = async () => {
  try {
    const first = await fetchOperatorsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchOperatorsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    operatorsTemp = collected;
    filteredOperators.value = [...collected];
    updatePagination();
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const switchOperator = (code) => {
  axios.post(`${backApi}/secure/operators/switch`, {
    code: code
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    showToast("Operation reussie", "green");
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
      showToast(error.response.data.message, "red");
    }
  });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/operators/${code}/status`, {
    code: code,
    status: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const showOperator = (code) => {
  axios.get(backApi + '/secure/operators/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.name = response.data.name || '';
      formValues.mnoName = response.data.mnoName || '';
      formValues.paymentMethod = response.data.paymentMethod || '';
      formValues.phoneCode = response.data.phoneCode || '';
      formValues.description = response.data.description || '';
      formValues.phoneMask = response.data.phoneMask || 0;
      formValues.otpInputMask = response.data.otpInputMask || '';

      selectedStatus.value = response.data.status || '';
      selectedOperationType.value = response.data.operationType || '';
      selectedProvider.value = response.data.provider?.code || '';
      selectedCountry.value = response.data.countryCode || '';
      
      selectedCheckOnlyAfterTimeout.value = response.data.checkOnlyAfterTimeout === true;
      selectedIsOtpRequired.value = response.data.isOtpRequired === true;

      countryCode = response.data.countryCode || '';
      countryName = response.data.countryName || '';

      itemCode = response.data.code;
      edit = 1;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          showToast("Erreur lors du chargement de l'opérateur", "red");
        }
      }
    });
}

const save = () => {
  if (edit == 0) {
    storeOperator()
  } else {
    updateProvidor()
  }
}

const storeOperator = async () => {
  try {
    schema.validateSync(formValues);

    const response = await axios.post(
      `${backApi}/secure/operators/new`,
      {
        name: formValues.name,
        mnoName: formValues.mnoName,
        status: selectedStatus.value,
        paymentMethod: formValues.paymentMethod,
        countryCode: countryCode,
        countryName: countryName,
        phoneCode: formValues.phoneCode,
        operationType: selectedOperationType.value,
        description: formValues.description,
        phoneMask: formValues.phoneMask,
        provider: selectedProvider.value,
        checkOnlyAfterTimeout: selectedCheckOnlyAfterTimeout.value === true,
        isOtpRequired: selectedIsOtpRequired.value === true,
        otpInputMask: formValues.otpInputMask || null
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }
    );

    if (response.status === 200) {
      showToast(
        "Operateur " + formValues.name.toLowerCase() + " enregistré avec succès",
        "green"
      );

      initField();

      setTimeout(() => {
        router.go();
      }, 1000);
    }

  } catch (error) {

    console.error("ERREUR COMPLETE :", error);

    // Erreur Yup
    if (error?.name === "ValidationError") {
      errors.value = error.message;
      showToast(error.message, "red");
      return;
    }

    // Erreur API
    if (error?.response) {
      console.error("Status API :", error.response.status);
      console.error("Data API :", error.response.data);

      if (error.response.status === 401) {
        router.push('/');
        return;
      }

      errorId.value = error.response.data?.errorId || '';
      errors.value =
        error.response.data?.message || "Une erreur est survenue";

      showToast(errors.value, "red");
      return;
    }

    // Autre erreur JS
    errors.value = error?.message || "Une erreur inattendue est apparue";
    showToast(errors.value, "red");
  }
};

const updateProvidor = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    
    axios.put(`${backApi}/secure/operators/${itemCode}/edit`, {
      name: formValues.name,
      description: formValues.description,
      mnoName: formValues.mnoName,
      status: selectedStatus.value,
      paymentMethod: formValues.paymentMethod,
      countryCode: countryCode,
      countryName: countryName,
      phoneCode: formValues.phoneCode,
      operationType: selectedOperationType.value,
      phoneMask: formValues.phoneMask,
      provider: selectedProvider.value,
      checkOnlyAfterTimeout: selectedCheckOnlyAfterTimeout.value === true,
      isOtpRequired: selectedIsOtpRequired.value === true,
      otpInputMask: formValues.otpInputMask || null,
      code: itemCode,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        setTimeout(() => {
          router.go();
        }, 1000);
      }
    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId || '';
          errors.value = error.response.data.message || 'Une erreur est survenue';
          showToast(errors.value, "red");
        }
      }
    });
  } catch (error) {
    errors.value = "Une erreur inattendue est apparue";
    showToast(errors.value, "red");
    btnLoad.value = true;
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

onMounted(async () => {
  checkSessionValidate(1)
  const route = useRoute();
  code = route.params.id;
  getFees();
  await getOperators();
  await getProviders();
  getOrganizations();
  getTypeFees();
  getCountries();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[30] || (_cache[30] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                onInput: filterOperators,
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: _ctx.$t('operators.searchPlaceholder')
              }, null, 40, _hoisted_5), [
                [_vModelText, searchQuery.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_unref(current_permissions)('create_operator'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#companyModal",
                    style: {"background-color":"#EB9355"},
                    onClick: initField
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('operators.addOperator')) + " ", 1),
                    _cache[31] || (_cache[31] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('operators.code')), 1),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('operators.operator')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('operators.mno')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('operators.provider')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('operators.operationType')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('operators.paymentMethod')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('operators.country')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('operators.countryCode')), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('operators.phoneCode')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('operators.phoneMask')), 1),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('operators.activationDelay')), 1),
                    _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('operators.isOtpRequired')), 1),
                    _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('operators.description')), 1),
                    _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('operators.status')), 1),
                    _cache[32] || (_cache[32] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (displayedOperators.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                        _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.$t('operators.noResults')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedOperators.value, (operator) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: operator.id
                    }, [
                      _createElementVNode("td", _hoisted_26, _toDisplayString(operator.code), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(operator.name === null ? '' : operator.name), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(operator.mnoName === null ? '' : operator.mnoName), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(operator.provider && operator.provider.name ? operator.provider.name : ''), 1),
                      (operator.operationType!==null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                            (operator.operationType==='1')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('operators.payin')), 1))
                              : _createCommentVNode("", true),
                            (operator.operationType==='2')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('operators.payout')), 1))
                              : _createCommentVNode("", true),
                            (operator.operationType==='3')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('operators.payinPayout')), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_34, _toDisplayString(operator.paymentMethod === null ? '' : operator.paymentMethod), 1),
                      _createElementVNode("td", _hoisted_35, _toDisplayString(operator.countryName === null ? '' : operator.countryName), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(operator.countryCode === null ? '' : operator.countryCode), 1),
                      _createElementVNode("td", _hoisted_37, _toDisplayString(operator.phoneCode === null ? '' : operator.phoneCode), 1),
                      _createElementVNode("td", _hoisted_38, _toDisplayString(operator.phoneMask === null ? '' : operator.phoneMask), 1),
                      _createElementVNode("td", _hoisted_39, [
                        (operator.checkOnlyAfterTimeout === true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.$t('operators.active')), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('operators.inactive')), 1))
                      ]),
                      _createElementVNode("td", _hoisted_42, [
                        (operator.isOtpRequired === true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.$t('operators.active')), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.$t('operators.inactive')), 1))
                      ]),
                      _createElementVNode("td", _hoisted_45, _toDisplayString(operator.description === null ? '' : operator.description), 1),
                      _createElementVNode("td", _hoisted_46, [
                        (operator.status==='ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.$t('operators.active')), 1))
                          : _createCommentVNode("", true),
                        (operator.status==='INACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.$t('operators.inactive')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _cache[36] || (_cache[36] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_51, [
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('switch_operator'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (switchOperator(operator.code))
                                  }, [
                                    _cache[33] || (_cache[33] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('operators.switch')), 1)
                                  ], 8, _hoisted_52))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('status_operator'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (changeStatus(operator.status,operator.code))
                                  }, [
                                    _cache[34] || (_cache[34] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    (operator.status==='ACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.$t('operators.deactivate')), 1))
                                      : _createCommentVNode("", true),
                                    (operator.status==='INACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.$t('operators.activate')), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_53))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('edit_operator'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#companyModal",
                                    onClick: ($event: any) => (showOperator(operator.code))
                                  }, [
                                    _cache[35] || (_cache[35] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('operators.edit')), 1)
                                  ], 8, _hoisted_56))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (total.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createElementVNode("p", _hoisted_59, [
                    _createTextVNode(_toDisplayString(_ctx.$t('operators.showing')) + " ", 1),
                    _createElementVNode("span", _hoisted_60, _toDisplayString(displayedOperators.value.length > 0 ? Math.min((page.value-1)*10 + 1, total.value) : 0), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('operators.to')) + " ", 1),
                    _createElementVNode("span", _hoisted_61, _toDisplayString(Math.min(page.value*10, total.value)), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('operators.outOf')) + " ", 1),
                    _createElementVNode("span", _hoisted_62, _toDisplayString(total.value), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('operators.results')), 1)
                  ]),
                  (numPages.value > 1)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_63, [
                        _createElementVNode("ul", _hoisted_64, [
                          ((page.value-1)>0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_65, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(page.value-1))),
                                  "aria-label": "Previous"
                                }, [...(_cache[37] || (_cache[37] = [
                                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginationPages.value, (numPage) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: numPage,
                              class: "page-item"
                            }, [
                              (numPage==page.value)
                                ? (_openBlock(), _createElementBlock("a", _hoisted_66, _toDisplayString(numPage), 1))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "page-link",
                                    onClick: ($event: any) => (goToPage(numPage))
                                  }, _toDisplayString(numPage), 9, _hoisted_67))
                            ]))
                          }), 128)),
                          ((page.value+1)<=numPages.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_68, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPage(page.value+1))),
                                  "aria-label": "Next"
                                }, [...(_cache[38] || (_cache[38] = [
                                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_69, [
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("h1", _hoisted_73, _toDisplayString(_unref(edit) == 0 ? _ctx.$t('operators.addOperator') : _ctx.$t('operators.editOperator')), 1),
              _cache[39] || (_cache[39] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_74, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _createElementVNode("h6", _hoisted_76, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_77, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    _createElementVNode("h6", _hoisted_79, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t('operators.name')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValues.name) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        placeholder: _ctx.$t('operators.namePlaceholder'),
                        onBlur: _cache[4] || (_cache[4] = ($event: any) => (validate('name'))),
                        onKeyup: _cache[5] || (_cache[5] = ($event: any) => (validate('name')))
                      }, null, 42, _hoisted_84), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_85, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t('operators.mno')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValues.mnoName) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['mnoName'] }]),
                        placeholder: _ctx.$t('operators.mnoPlaceholder'),
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (validate('mnoName'))),
                        onKeyup: _cache[8] || (_cache[8] = ($event: any) => (validate('mnoName')))
                      }, null, 42, _hoisted_88), [
                        [_vModelText, formValues.mnoName]
                      ]),
                      _createElementVNode("span", _hoisted_89, _toDisplayString(errorsBis['mnoName']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.$t('operators.status')), 1),
                    _withDirectives(_createElementVNode("select", {
                      name: "status",
                      id: "status",
                      class: "form-select fs-md-15 text-black shadow-none",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedStatus).value = $event)),
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_93, _toDisplayString(_ctx.$t('operators.select')), 1),
                      _cache[40] || (_cache[40] = _createElementVNode("option", { value: "ACTIVE" }, "ACTIVE", -1)),
                      _cache[41] || (_cache[41] = _createElementVNode("option", { value: "INACTIVE" }, "INACTIVE", -1))
                    ], 512), [
                      [_vModelSelect, selectedStatus.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t('operators.paymentMethod')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formValues.paymentMethod) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['paymentMethod'] }]),
                        placeholder: _ctx.$t('operators.paymentMethodPlaceholder'),
                        onBlur: _cache[11] || (_cache[11] = ($event: any) => (validate('paymentMethod'))),
                        onKeyup: _cache[12] || (_cache[12] = ($event: any) => (validate('paymentMethod')))
                      }, null, 42, _hoisted_96), [
                        [_vModelText, formValues.paymentMethod]
                      ]),
                      _createElementVNode("span", _hoisted_97, _toDisplayString(errorsBis['paymentMethod']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t('operators.phoneCode')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formValues.phoneCode) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['phoneCode'] }]),
                        placeholder: _ctx.$t('operators.phoneCodePlaceholder'),
                        onBlur: _cache[14] || (_cache[14] = ($event: any) => (validate('phoneCode'))),
                        onKeyup: _cache[15] || (_cache[15] = ($event: any) => (validate('phoneCode')))
                      }, null, 42, _hoisted_101), [
                        [_vModelText, formValues.phoneCode]
                      ]),
                      _createElementVNode("span", _hoisted_102, _toDisplayString(errorsBis['phoneCode']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.$t('operators.operationType')), 1),
                    _withDirectives(_createElementVNode("select", {
                      name: "operationType",
                      id: "operationType",
                      class: "form-select fs-md-15 text-black shadow-none",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((selectedOperationType).value = $event)),
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_105, _toDisplayString(_ctx.$t('operators.select')), 1),
                      _createElementVNode("option", _hoisted_106, _toDisplayString(_ctx.$t('operators.payin')), 1),
                      _createElementVNode("option", _hoisted_107, _toDisplayString(_ctx.$t('operators.payout')), 1),
                      _createElementVNode("option", _hoisted_108, _toDisplayString(_ctx.$t('operators.payinPayout')), 1)
                    ], 512), [
                      [_vModelSelect, selectedOperationType.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.$t('operators.provider')), 1),
                    _withDirectives(_createElementVNode("select", {
                      name: "provider",
                      id: "provider",
                      class: "form-select fs-md-15 text-black shadow-none",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((selectedProvider).value = $event)),
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_112, _toDisplayString(_ctx.$t('operators.select')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providers.value, (provider) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: provider.code,
                          key: provider.code
                        }, _toDisplayString(provider.name), 9, _hoisted_113))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, selectedProvider.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t('operators.activationDelay')), 1),
                    _withDirectives(_createElementVNode("select", {
                      name: "checkOnlyAfterTimeout",
                      id: "checkOnlyAfterTimeout",
                      class: "form-select fs-md-15 text-black shadow-none",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((selectedCheckOnlyAfterTimeout).value = $event)),
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_116, _toDisplayString(_ctx.$t('operators.select')), 1),
                      _createElementVNode("option", _hoisted_117, _toDisplayString(_ctx.$t('operators.inactive')), 1),
                      _createElementVNode("option", _hoisted_118, _toDisplayString(_ctx.$t('operators.active')), 1)
                    ], 512), [
                      [_vModelSelect, selectedCheckOnlyAfterTimeout.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.$t('operators.phoneMask')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formValues.phoneMask) = $event)),
                        type: "number",
                        min: "0",
                        max: "15",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['phoneMask'] }]),
                        placeholder: _ctx.$t('operators.phoneMaskPlaceholder'),
                        onBlur: _cache[20] || (_cache[20] = ($event: any) => (validate('phoneMask'))),
                        onKeyup: _cache[21] || (_cache[21] = ($event: any) => (validate('phoneMask')))
                      }, null, 42, _hoisted_122), [
                        [_vModelText, formValues.phoneMask]
                      ]),
                      _createElementVNode("span", _hoisted_123, _toDisplayString(errorsBis['phoneMask']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_124, [
                    _createElementVNode("label", _hoisted_125, _toDisplayString(_ctx.$t('operators.country')), 1),
                    _withDirectives(_createElementVNode("select", {
                      name: "country",
                      id: "country",
                      class: "form-select fs-md-15 text-black shadow-none",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((selectedCountry).value = $event)),
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_126, _toDisplayString(_ctx.$t('operators.select')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: country.countryCode,
                          key: country.code
                        }, _toDisplayString(country.name), 9, _hoisted_127))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, selectedCountry.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("label", _hoisted_130, _toDisplayString(_ctx.$t('operators.isOtpRequired')), 1),
                    _withDirectives(_createElementVNode("select", {
                      name: "isOtpRequired",
                      id: "isOtpRequired",
                      class: "form-select fs-md-15 text-black shadow-none",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((selectedIsOtpRequired).value = $event)),
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_131, _toDisplayString(_ctx.$t('operators.select')), 1),
                      _createElementVNode("option", _hoisted_132, _toDisplayString(_ctx.$t('operators.inactive')), 1),
                      _createElementVNode("option", _hoisted_133, _toDisplayString(_ctx.$t('operators.active')), 1)
                    ], 512), [
                      [_vModelSelect, selectedIsOtpRequired.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.$t('operators.otpInputMask')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formValues.otpInputMask) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['otpInputMask'] }]),
                        placeholder: _ctx.$t('operators.otpInputMaskPlaceholder'),
                        onBlur: _cache[25] || (_cache[25] = ($event: any) => (validate('otpInputMask'))),
                        onKeyup: _cache[26] || (_cache[26] = ($event: any) => (validate('otpInputMask')))
                      }, null, 42, _hoisted_136), [
                        [_vModelText, formValues.otpInputMask]
                      ]),
                      _createElementVNode("span", _hoisted_137, _toDisplayString(errorsBis['otpInputMask']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("div", _hoisted_139, [
                    _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.$t('operators.description')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formValues.description) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                        placeholder: _ctx.$t('operators.descriptionPlaceholder'),
                        onBlur: _cache[28] || (_cache[28] = ($event: any) => (validate('description'))),
                        onKeyup: _cache[29] || (_cache[29] = ($event: any) => (validate('description')))
                      }, null, 42, _hoisted_141), [
                        [_vModelText, formValues.description]
                      ]),
                      _createElementVNode("span", _hoisted_142, _toDisplayString(errorsBis['description']), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_143, [
              (_unref(current_permissions)('create_operator', 'edit_operator'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_144, [
                    _cache[42] || (_cache[42] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(edit) == 0 ? _ctx.$t('operators.save') : _ctx.$t('operators.edit')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[43] || (_cache[43] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})